import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me", { validateStatus: (s) => s < 500 || s === 401 });
            if (data && data.user_id) {
                setUser(data);
            } else {
                setUser(null);
            }
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        checkAuth();
    }, [checkAuth]);

    const logout = useCallback(async () => {
        try {
            await api.post("/auth/logout");
        } catch {
            // Cookie may already be gone — clearing local state is enough.
        }
        setUser(null);
    }, []);

    // Memoize context value so consumers don't re-render on every provider render.
    const value = useMemo(
        () => ({ user, setUser, loading, refresh: checkAuth, logout }),
        [user, loading, checkAuth, logout],
    );

    return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
